export const getDoctorsPiState = state => state?.doctorsPi;
